/**
 * Who to name above a message bubble in the ticket thread.
 *
 * Outbound replies carry `sent_by` (the Prism user id). Only the reader's
 * own replies say "You"; a colleague's reply gets their name, so a thread
 * somebody else has already answered reads that way at a glance.
 */

export const HOUSE_NAME = 'Audio Trader'
const CUSTOMER_FALLBACK = 'Customer'

export function replyAuthorLabel(reply, { currentUserId, ticketUsers = [], customerName }) {
  if (reply.direction !== 'out') return customerName || CUSTOMER_FALLBACK
  if (reply.sent_by != null && reply.sent_by === currentUserId) return 'You'
  return userName(ticketUsers, reply.sent_by) || HOUSE_NAME
}

function userName(ticketUsers, userId) {
  if (userId == null) return null
  const match = ticketUsers.find(u => (u.user_id ?? u.id) === userId)
  return match?.name || null
}
